module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-profile text-dark"
  }, [(_vm.schoolIsFromDenmark) ? [(!_vm.theUser || !_vm.schoolId) ? _c('Loader') : [_c('div', {
    staticClass: "marg-1-top"
  }), _vm._v(" "), _c('ProfileSubjects', {
    staticClass: "marg-1-top",
    attrs: {
      "canEdit": _vm.isUserCanEdit,
      "schoolId": _vm.schoolId,
      "user": _vm.user
    }
  })]] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3523b31c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/Profile.vue
// module id = 1581
// module chunks = 1